import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import CustomListComponent from '../../../components/base/CustomListComponent';
import { NavBarNames } from '../../../config/NavBarNameList';
import DeletePrompt from '../../../components/base/DeletePrompt';
import BaseTabListContainer from '../../base/BaseTabListContainer';
import BaseListContainer from '../../base/BaseListContainer';
import AuthButton from '../../../components/base/AuthButton';
import { PermissionCodes } from '../../../config/PermissionCodes';
import { DELETE_RELATED_SECTIONS } from '../../../config/CustomEnums';
import ListButtonsGroup from '../../../components/base/ListButtonsGroup';
import Filter from './Filter';

const queryString = require('query-string');

function NewsFeedList({
  listFields,
  dataList,
  pageInfo,
  totalPage,
  totalCount,
  checkedList
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();

  const [showDeletePrompt, setShowDeletePrompt] = useState(false);

  const createObjectAction = () => {
    history.push('/news_feeds/create');
  };

  const buttons = [
    <ListButtonsGroup
      hideExtraButtonWidth={500}
      extraButtons={[
        <AuthButton
          title="Create News Feed"
          action={createObjectAction}
          requires={PermissionCodes.changeNewsFeed}
          customClass={'btn-further'}
        />,
      ]}
      extraPopContent={[
        {
          requires: PermissionCodes.changeNewsFeed,
          action: createObjectAction,
          content: 'Create News Feed',
        },
      ]}
    />,
  ];

  const groupActions = [
    {
      name: 'Delete',
      action: () => {
        setShowDeletePrompt(true);
      },
      requires: PermissionCodes.changeNewsFeed,
    },
  ];

  const tabs = [
    {
      name: '',
      content: (
        <BaseTabListContainer
          hideTab={true}
          tabs={[]}
          groupActions={groupActions}
          pageInfo={pageInfo}
          totalCount={totalCount}
          filter={{
            hasFilter: true,
            componment: Filter,
          }}
          listContent={
            <BaseListContainer
              fields={listFields}
              dataList={dataList}
              totalPage={totalPage}
              model={'newsFeedModel'}
              permissionGroup={PermissionCodes.newsFeed}
              deleteInfo={{
                data: [],
                title: 'news feed',
                relatedName: '',
                onComfirm: {},
                relatedSections: DELETE_RELATED_SECTIONS.NEWS_FEED,
              }}
              rankDisabled
              actions={['Edit', 'Duplicate', 'Delete']}
              hasOtherActions={true}
              customActions={{
                publish: (item) => {
                  dispatch({
                    type: 'newsFeedModel/publishOrUnpublishNewsFeed',
                    payload: {
                      id: item.pk,
                      isPublish: item.isPublished ? false : true,
                      afterAction: () => { history.push(location) },
                    },
                  });
                },
              }}
            />
          }
        />
      ),
    },
  ];

  useEffect(() => {
    dispatch({ type: 'newsFeedModel/clearData' });
    if (queryString) {
      const querySearch = queryString.parse(location.search);
      const searchKey = querySearch['search'] || '';
      const stringRank = querySearch['rank'] || 'true';
      const stringPage = querySearch['page'] || 1;
      const rank = stringRank === 'true';
      const page = parseInt(stringPage);

      dispatch({
        type: 'newsFeedModel/getList',
        payload: {
          ...querySearch,
          page,
          reverse: rank,
          search: searchKey,
        },
      });
    }
  }, [location]);

  return (
    <>
      <CustomListComponent
        caution={{
          detail: null,
          title: NavBarNames.newsFeed,
        }}
        defaultActiveKey={tabs[0].name}
        breadcrumb={<CustomBreadcrumb />}
        buttons={buttons}
        tabs={tabs}
        hideTab={false}
      />
      <DeletePrompt
        data={checkedList}
        title={'news feeds'}
        relatedName={''}
        relatedSections={DELETE_RELATED_SECTIONS.NEWS_FEED}
        show={showDeletePrompt}
        onClose={() => setShowDeletePrompt(false)}
        onConfirm={() => {
          setShowDeletePrompt(false);
          dispatch({
            type: 'newsFeedModel/delete',
            payload: {
              afterAction: () => {
                history.push(location);
              },
            },
          });
        }}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  listFields: state.newsFeedModel.listDisplayFields,
  dataList: state.newsFeedModel.pagedList,
  pageInfo: state.newsFeedModel.pageInfo,
  totalPage: state.newsFeedModel.totalPage,
  totalCount: state.newsFeedModel.totalCount,
  checkedList: state.newsFeedModel.checkedList,
})

export default connect(mapStateToProps)(NewsFeedList);
